import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import _ from 'lodash'
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import InventoryLocationTransactions from './InventoryLocationTransactions'
import { inject, observer } from 'mobx-react';
import {pending} from '../stores/State'

@inject('store')
@observer
class InventoryLocation extends Component {

  componentDidMount(){
    this.fetchInventoryLocation(this.props.match.params.id);
  }

  fetchInventoryLocation(inventoryLocationId){
    const store  = this.props.store.inventoryLocationStore;
    store.fetchInventoryLocation(inventoryLocationId);    
  }

  render() {
    const { classes } = this.props;
    const inventoryLocationId  = _.parseInt(this.props.match.params.id);
    const store  = this.props.store.inventoryLocationStore;
    const inventoryLocation = store.inventoryLocation;
    
    return (
      <div>
        {store.inventoryLocationState === pending && <CircularProgress className={classes.progress} />}
        {inventoryLocation && 
          <Grid container spacing={24}>
              <Grid item xs={12}>
                <Typography variant='display3' className={classes.title}>{inventoryLocation.name}</Typography>
              </Grid>

              <Grid item xs={6} sm={4}>
                <Paper className={classes.paper}>
                  <Typography align='center' variant='display3'>{(inventoryLocation.fill_rate*100).toFixed(0)}%</Typography>
                  <Typography align='center' variant='subheading'>Fill rate</Typography>
                </Paper>    
              </Grid>
              
              <Grid item xs={6} sm={4}>
                <Paper className={classes.paper}>
                  <Typography align='center' variant='display3'>{inventoryLocation.inventory_count}/{inventoryLocation.capacity}</Typography>
                  <Typography align='center' variant='subheading'>Inventory count</Typography>
                </Paper>    
              </Grid>

              <Grid item xs={6} sm={4}>
                <Paper className={classes.paper}>
                  <Typography align='center' variant='display3'>{inventoryLocation.inventory_weight} kg</Typography>
                  <Typography align='center' variant='subheading'>Inventory weight</Typography>
                </Paper>    
              </Grid>

              <Grid item xs={6} sm={4}>
                <Paper className={classes.paper}>
                  <Typography align='center' variant='display3'>{inventoryLocation.total_transactions_count}</Typography>
                  <Typography align='center' variant='subheading'>All time count</Typography>
                </Paper>    
              </Grid>

              <Grid item xs={6} sm={4}>
                <Paper className={classes.paper}>
                  <Typography align='center' variant='display3'>{inventoryLocation.total_transactions_weight} kg</Typography>
                  <Typography align='center' variant='subheading'>All time weight</Typography>
                </Paper>    
              </Grid>

              <Grid item xs={12}>
                <InventoryLocationTransactions inventoryLocationId={inventoryLocationId}/>
              </Grid>

              { (inventoryLocation.address || inventoryLocation.collection_time || inventoryLocation.phone || inventoryLocation.email || inventoryLocation.contact_person_name ) &&
              <Grid item xs={12} sm={6}>
                <Paper className={classes.paper}>
                  <Typography variant='display1'>Location details</Typography>
                  {inventoryLocation.address && <Typography variant='body1'>Address: {inventoryLocation.address}</Typography>}
                  {inventoryLocation.collection_time && <Typography variant='body1'>Time: {inventoryLocation.collection_time}</Typography>}
                  {inventoryLocation.phone && <Typography variant='body1'>Phone: {inventoryLocation.phone}</Typography>}
                  {inventoryLocation.email && <Typography variant='body1'>Email: {inventoryLocation.email}</Typography>}
                  {inventoryLocation.contact_person_name && <Typography variant='body1'>Contact person: {inventoryLocation.contact_person_name}</Typography>}
                </Paper>    
              </Grid>
              }
          </Grid>
        }
      </div>
    );
  }
}


const styles = theme => ({
  title: {
    marginBottom: 10
  },
  paper:{
    padding: 20
  }
});

export default withStyles(styles)(InventoryLocation);



// WEBPACK FOOTER //
// ./src/components/InventoryLocation.js